import { initComponent } from './core/init-component.js'
import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

initComponent('.js-featured-products-grid', section => {
  const slider = section.querySelector('.js-featured-products-grid-swiper')
  const prevEl = section.querySelector('.js-slider-prev')
  const nextEl = section.querySelector('.js-slider-next')
  const slidesCount = section.querySelectorAll('.js-slide').length

  if (!slider || !prevEl || !nextEl) return

  const swiper = new Swiper(slider, {
    modules: [Navigation],
    slidesPerView: slidesCount > 1 ? 1.345 : 1,
    spaceBetween: 8,
    slidesPerGroup: 1,
    slidesOffsetBefore: slidesCount > 1 ? 16 : 0,
    slidesOffsetAfter: slidesCount > 1 ? 16 : 0,
    freeMode: false,
    navigation: {
      prevEl,
      nextEl
    },
    breakpoints: {
      768: {
        slidesPerView: slidesCount > 0 ? slidesCount : 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        spaceBetween: 16,
      }
    }
  })

  return {
    unload() {
      swiper.destroy()
    }
  }
})
